import { Component } from '@angular/core';

@Component({
  selector: 'app-prescription-footer',
  templateUrl: './prescription-footer.component.html',
  styleUrls: ['./prescription-footer.component.css']
})
export class PrescriptionFooterComponent {

}
